/**
 * Provider definitions for WorkflowTools Quick Connect section.
 */

export interface ProviderField {
  key: string;
  label: string;
  placeholder: string;
  type?: "text" | "password" | "number";
  defaultValue?: string;
}

export interface ProviderDefinition {
  id: string;
  name: string;
  icon: string;
  color: string;
  bgColor: string;
  description: string;
  namespace: string;
  fields: ProviderField[];
}

export const PROVIDERS: ProviderDefinition[] = [
  {
    id: "snowflake",
    name: "Snowflake",
    icon: "\u2744\uFE0F",
    color: "#29B5E8",
    bgColor: "rgba(41, 181, 232, 0.08)",
    description: "Cloud data warehouse",
    namespace: "databases",
    fields: [
      { key: "account", label: "Account", placeholder: "xy12345.us-east-1" },
      { key: "user", label: "User", placeholder: "ANALYTICS_USER" },
      { key: "password", label: "Password", placeholder: "Enter password", type: "password" },
      { key: "warehouse", label: "Warehouse", placeholder: "COMPUTE_WH" },
      { key: "database", label: "Database", placeholder: "ANALYTICS_DB" },
      { key: "schema", label: "Schema", placeholder: "PUBLIC" },
    ],
  },
  {
    id: "postgresql",
    name: "PostgreSQL",
    icon: "\uD83D\uDC18",
    color: "#336791",
    bgColor: "rgba(51, 103, 145, 0.08)",
    description: "Relational database",
    namespace: "databases",
    fields: [
      { key: "host", label: "Host", placeholder: "db.example.com" },
      { key: "port", label: "Port", placeholder: "5432", type: "number", defaultValue: "5432" },
      { key: "database", label: "Database", placeholder: "mydb" },
      { key: "user", label: "User", placeholder: "postgres" },
      { key: "password", label: "Password", placeholder: "Enter password", type: "password" },
    ],
  },
  {
    id: "bigquery",
    name: "BigQuery",
    icon: "\uD83D\uDDC2\uFE0F",
    color: "#4285F4",
    bgColor: "rgba(66, 133, 244, 0.08)",
    description: "Google Cloud analytics",
    namespace: "databases",
    fields: [
      { key: "project_id", label: "Project ID", placeholder: "my-gcp-project" },
      { key: "dataset", label: "Dataset", placeholder: "analytics" },
      { key: "credentials_json", label: "Credentials JSON", placeholder: '{"type": "service_account", ...}', type: "password" },
    ],
  },
  {
    id: "databricks",
    name: "Databricks",
    icon: "\u26A1",
    color: "#FF3621",
    bgColor: "rgba(255, 54, 33, 0.08)",
    description: "Unified analytics platform",
    namespace: "databases",
    fields: [
      { key: "host", label: "Host", placeholder: "adb-1234567890.12.azuredatabricks.net" },
      { key: "token", label: "Access Token", placeholder: "dapi...", type: "password" },
      { key: "sql_warehouse_id", label: "SQL Warehouse ID", placeholder: "abc123def456" },
    ],
  },
  {
    id: "redshift",
    name: "Redshift",
    icon: "\uD83D\uDE80",
    color: "#8C4FFF",
    bgColor: "rgba(140, 79, 255, 0.08)",
    description: "AWS data warehouse",
    namespace: "databases",
    fields: [
      { key: "host", label: "Host", placeholder: "cluster.abc123.us-east-1.redshift.amazonaws.com" },
      { key: "port", label: "Port", placeholder: "5439", type: "number", defaultValue: "5439" },
      { key: "database", label: "Database", placeholder: "analytics" },
      { key: "user", label: "User", placeholder: "admin" },
      { key: "password", label: "Password", placeholder: "Enter password", type: "password" },
    ],
  },
  {
    id: "clickhouse",
    name: "ClickHouse",
    icon: "\uD83D\uDFE1",
    color: "#FFCC00",
    bgColor: "rgba(255, 204, 0, 0.08)",
    description: "Column-oriented OLAP database",
    namespace: "databases",
    fields: [
      { key: "url", label: "URL", placeholder: "https://clickhouse.example.com:8443" },
      { key: "user", label: "User", placeholder: "default" },
      { key: "password", label: "Password", placeholder: "Enter password", type: "password" },
    ],
  },
];
